import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  root: {
    alignSelf: 'flex-end',
  },
}))

export default useStyles
